import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { CodeProjectService } from '../code-project.service';
import { CodeProject } from '../code-project';

@Component({
    selector: 'app-code-project',
    templateUrl: './code-project.component.html',
    styleUrls: ['./code-project.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class CodeProjectComponent implements OnInit {
    employees: any;
    categories: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private codeProjectService: CodeProjectService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.codeProject = data.codeProject,
			this.statuses = codeProjectService.statuses;
			this.employees = codeProjectService.employees;
			this.categories = codeProjectService.categories;
	}

	@Input() codeProject: CodeProject;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	codeProjectId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'codeProjectId': [],
		'projectName': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'projectDesc': [],
		'status': [],
		'assignedTo': [],
		'assignedDate': [],
		'category': [],
	};
	
	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole codeProject object
		if (this.codeProject) {
			this.codeProjectId = this.codeProject.codeProjectId;
			if(this.codeProject.assignedDate != undefined && this.codeProject.assignedDate != null){
				this.codeProject.assignedDate = moment.utc(this.codeProject.assignedDate).format('MM/DD/YYYY');
			}
			this.fixDates();
			this.form1.patchValue(this.codeProject);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.codeProjectId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.codeProjectService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.codeProject = res.data.codeProject;
						this.codeProjectId = this.codeProject.codeProjectId;
						this.doAdd.emit(this.codeProject);
					},
					(err: any) => {
						console.log('codeProject-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('codeProject: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			console.log("this.form1.value.assignedDate :"+this.form1.value.assignedDate);
			this.form1.value.assignedDate = moment.utc(this.form1.value.assignedDate.toLocaleString());
			this.codeProjectService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.codeProject = res.data.codeProject;
						this.doUpdate.emit(this.codeProject);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.codeProjectService.delete(this.codeProject.codeProjectId)
				.subscribe(
					(res: any) => {
						console.log('codeProject-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.codeProject);
					},
					(err: any) => {
						console.log('codeProject-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			codeProjectId: [this.codeProjectId],
			projectName: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			projectDesc: [],
			status: ['open'],
			assignedTo: [],
			assignedDate: [moment.utc().toDate()],
			category: ['task'],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.codeProject.codeProjectDate = moment.utc(this.codeProject.codeProjectDate).toDate();
	}
	
}
